/**
 * Centralized application configuration.
 */
export const appConfig = {
    app: {
        name: 'REMUS Web',
        description: 'CERN Radiation Monitoring web application',
    },

    header: {
        alwaysDisplayGitLab: false,
        alwaysDisplayAllDocs: false,
    },

    branding: {
        logo: {
            path: '/logo-header.png',
            alt: 'REMUS logo',
            height: 32,
        },
    },

    links: {
        gitlab: 'https://gitlab.cern.ch/hse-see-co/REMUS/remus-web',
    },

    userConfigurationsKey: 'userConfigurations',

    activeRolesFeature: {
        active: true,         // Multi-role UI filter. Backend always trusts the JWT; this only narrows what the UI shows.
        exclusiveMode: false, // false: user can keep multiple active roles; true: one at a time.
    },

    pwa: {
        installBanner: true,
    },
} as const;

export type AppConfig = typeof appConfig;
